module.exports = __webpack_public_path__ + "img/patternSG.8cfa9305.png";